import { z } from 'zod';
import { SyncableEntitySchema } from './entity';

export const PaperTypeSchema = z.enum(['PAPER_I', 'PAPER_II', 'STRUCTURED_ESSAY']);
export type PaperType = z.infer<typeof PaperTypeSchema>;

export const PaperStatusSchema = z.enum(['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED']);
export type PaperStatus = z.infer<typeof PaperStatusSchema>;

export const DifficultyLevelSchema = z.enum(['EASY', 'MEDIUM', 'HARD']).nullable();
export type DifficultyLevel = z.infer<typeof DifficultyLevelSchema>;

export const PastPaperSchema = SyncableEntitySchema.extend({
  subjectId: z.string().uuid(),
  year: z.number().int().min(1900).max(2100),
  paperType: PaperTypeSchema,
  status: PaperStatusSchema.default('NOT_STARTED'),
  difficulty: DifficultyLevelSchema.default(null),
  isRevisionRequired: z.boolean().default(false),
  score: z.number().min(0).max(100).nullable().default(null),
  notes: z.string().default(''),
  fileAttachmentUri: z.string().nullable().default(null),
});

export type PastPaper = z.infer<typeof PastPaperSchema>;
